import EditNoteIcon from '@mui/icons-material/EditNote';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type React from 'react';
import type { Client } from 'services/types/client';
import { NAVY, RADIUS_CARD, SHADOW_CARD, SURFACE_CONTAINER_LOWEST } from 'styles/tokens';

import ClientNotesEditor from './ClientNotesEditor';

interface Props {
  client: Client;
}

const ClientNotesCard: React.FC<Props> = ({ client }) => (
  <Box
    sx={{
      backgroundColor: SURFACE_CONTAINER_LOWEST,
      borderRadius: RADIUS_CARD,
      boxShadow: SHADOW_CARD,
      p: 2,
      mb: 1.5,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      <EditNoteIcon sx={{ color: alpha(NAVY, 0.6), fontSize: 20 }} />
      <Typography variant="body1" sx={{ fontWeight: 600, fontSize: '0.95rem', color: NAVY }}>
        Notas
      </Typography>
    </Box>
    <ClientNotesEditor client={client} />
  </Box>
);

export default ClientNotesCard;
